/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ComponentTypeDto } from '../models';
// @ts-ignore
import type { ComponentTypeIdDto } from '../models';
// @ts-ignore
import type { ComponentTypeSearchRequestDto } from '../models';
// @ts-ignore
import type { ComponentTypesSearchResponseDto } from '../models';
// @ts-ignore
import type { CreateComponentTypeRequestDto } from '../models';
// @ts-ignore
import type { UpdateComponentTypeRequestDto } from '../models';
/**
 * RestComponentTypesApi - axios parameter creator
 */
export const RestComponentTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateComponentTypeRequestDto} createComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentType: async (createComponentTypeRequestDto: CreateComponentTypeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createComponentTypeRequestDto' is not null or undefined
            assertParamExists('createComponentType', 'createComponentTypeRequestDto', createComponentTypeRequestDto)
            const localVarPath = `/api/component-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createComponentTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentType: async (componentTypeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentTypeId' is not null or undefined
            assertParamExists('getComponentType', 'componentTypeId', componentTypeId)
            const localVarPath = `/api/component-types/{componentTypeId}`
                .replace('{componentTypeId}', encodeURIComponent(String(componentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of component types
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentTypeSearchRequestDto} componentTypeSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentTypes: async (page: number, pageSize: number, componentTypeSearchRequestDto: ComponentTypeSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchComponentTypes', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchComponentTypes', 'pageSize', pageSize)
            // verify required parameter 'componentTypeSearchRequestDto' is not null or undefined
            assertParamExists('searchComponentTypes', 'componentTypeSearchRequestDto', componentTypeSearchRequestDto)
            const localVarPath = `/api/component-types/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(componentTypeSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {UpdateComponentTypeRequestDto} updateComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComponentType: async (componentTypeId: number, updateComponentTypeRequestDto: UpdateComponentTypeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'componentTypeId' is not null or undefined
            assertParamExists('updateComponentType', 'componentTypeId', componentTypeId)
            // verify required parameter 'updateComponentTypeRequestDto' is not null or undefined
            assertParamExists('updateComponentType', 'updateComponentTypeRequestDto', updateComponentTypeRequestDto)
            const localVarPath = `/api/component-types/{componentTypeId}`
                .replace('{componentTypeId}', encodeURIComponent(String(componentTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateComponentTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestComponentTypesApi - functional programming interface
 */
export const RestComponentTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestComponentTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateComponentTypeRequestDto} createComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComponentType(createComponentTypeRequestDto: CreateComponentTypeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentTypeIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComponentType(createComponentTypeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentTypesApi.createComponentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComponentType(componentTypeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentTypeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComponentType(componentTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentTypesApi.getComponentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of component types
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentTypeSearchRequestDto} componentTypeSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchComponentTypes(page: number, pageSize: number, componentTypeSearchRequestDto: ComponentTypeSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentTypesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchComponentTypes(page, pageSize, componentTypeSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentTypesApi.searchComponentTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {UpdateComponentTypeRequestDto} updateComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComponentType(componentTypeId: number, updateComponentTypeRequestDto: UpdateComponentTypeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComponentType(componentTypeId, updateComponentTypeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestComponentTypesApi.updateComponentType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestComponentTypesApi - factory interface
 */
export const RestComponentTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestComponentTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateComponentTypeRequestDto} createComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComponentType(createComponentTypeRequestDto: CreateComponentTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypeIdDto> {
            return localVarFp.createComponentType(createComponentTypeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComponentType(componentTypeId: number, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypeDto> {
            return localVarFp.getComponentType(componentTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of component types
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ComponentTypeSearchRequestDto} componentTypeSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchComponentTypes(page: number, pageSize: number, componentTypeSearchRequestDto: ComponentTypeSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypesSearchResponseDto> {
            return localVarFp.searchComponentTypes(page, pageSize, componentTypeSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} componentTypeId 
         * @param {UpdateComponentTypeRequestDto} updateComponentTypeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComponentType(componentTypeId: number, updateComponentTypeRequestDto: UpdateComponentTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateComponentType(componentTypeId, updateComponentTypeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestComponentTypesApi - interface
 */
export interface RestComponentTypesApiInterface {
    /**
     * 
     * @param {CreateComponentTypeRequestDto} createComponentTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createComponentType(createComponentTypeRequestDto: CreateComponentTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypeIdDto>;

    /**
     * 
     * @param {number} componentTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComponentType(componentTypeId: number, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypeDto>;

    /**
     * 
     * @summary Get list of component types
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ComponentTypeSearchRequestDto} componentTypeSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchComponentTypes(page: number, pageSize: number, componentTypeSearchRequestDto: ComponentTypeSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ComponentTypesSearchResponseDto>;

    /**
     * 
     * @param {number} componentTypeId 
     * @param {UpdateComponentTypeRequestDto} updateComponentTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateComponentType(componentTypeId: number, updateComponentTypeRequestDto: UpdateComponentTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestComponentTypesApi - object-oriented interface
 */
export class RestComponentTypesApi extends BaseAPI implements RestComponentTypesApiInterface {
    /**
     * 
     * @param {CreateComponentTypeRequestDto} createComponentTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createComponentType(createComponentTypeRequestDto: CreateComponentTypeRequestDto, options?: RawAxiosRequestConfig) {
        return RestComponentTypesApiFp(this.configuration).createComponentType(createComponentTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} componentTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getComponentType(componentTypeId: number, options?: RawAxiosRequestConfig) {
        return RestComponentTypesApiFp(this.configuration).getComponentType(componentTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of component types
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ComponentTypeSearchRequestDto} componentTypeSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchComponentTypes(page: number, pageSize: number, componentTypeSearchRequestDto: ComponentTypeSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestComponentTypesApiFp(this.configuration).searchComponentTypes(page, pageSize, componentTypeSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} componentTypeId 
     * @param {UpdateComponentTypeRequestDto} updateComponentTypeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateComponentType(componentTypeId: number, updateComponentTypeRequestDto: UpdateComponentTypeRequestDto, options?: RawAxiosRequestConfig) {
        return RestComponentTypesApiFp(this.configuration).updateComponentType(componentTypeId, updateComponentTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

